import {
    faArrowRightArrowLeft,
    faArrowsRotate,
    faBolt,
    faBrain,
    faBuilding,
    faChartLine,
    faChessKnight,
    faCircleNodes,
    faClock,
    faCodeBranch,
    faCodeCompare,
    faCubes,
    faDatabase,
    faDiagramProject,
    faFileCode,
    faFlaskVial,
    faGears,
    faGraduationCap,
    faHistory,
    faLayerGroup,
    faLightbulb,
    faMapLocationDot,
    faNetworkWired,
    faBuildingColumns,
    faReceipt,
    faRoute,
    faTrain,
    faRocket,
    faRobot,
    faRotate,
    faShieldHalved,
    faSitemap,
    faTableCells,
    faTerminal,
    faTheaterMasks,
    faUserDoctor
} from "@fortawesome/free-solid-svg-icons";

import MicroAgentTrap from "../components/Blog/posts/MicroAgentTrap";
import AiNativeSemantics from "../components/Blog/posts/AiNativeSemantics";
import ProvenanceByDesign from "../components/Blog/posts/ProvenanceByDesign";
import AiNativeOrganisation from "../components/Blog/posts/AiNativeOrganisation";
import DecisionSpaces from "../components/Blog/posts/DecisionSpaces";
import AgenticEnterprise from "../components/Blog/posts/AgenticEnterprise";
import AgentsProcessCoordination from "../components/Blog/posts/AgentsProcessCoordination";
import AgentHandovers from "../components/Blog/posts/AgentHandovers";
import AiNativeProcesses from "../components/Blog/posts/AiNativeProcesses";
import KnowledgeRevolution from "../components/Blog/posts/KnowledgeRevolution";
import Move37Semantics from "../components/Blog/posts/Move37Semantics";
import ContextGraphsClarity from "../components/Blog/posts/ContextGraphsClarity";
import DynamicEmergentSystems from "../components/Blog/posts/DynamicEmergentSystems";
import ContextGraphsTimeMachine from "../components/Blog/posts/ContextGraphsTimeMachine";
import ContextGraphsPointInTime from "../components/Blog/posts/ContextGraphsPointInTime";
import Building21stCenturyOrg from "../components/Blog/posts/Building21stCenturyOrg";
import KnowledgeFlywheel from "../components/Blog/posts/KnowledgeFlywheel";
import ContextGraphsConfusion from "../components/Blog/posts/ContextGraphsConfusion";
import KnowledgeVsContextGraphs from "../components/Blog/posts/KnowledgeVsContextGraphs";
import ContextGraphsCollision from "../components/Blog/posts/ContextGraphsCollision";
import NewEraInformationRepresentation from "../components/Blog/posts/NewEraInformationRepresentation";
import DoctorDog from "../components/Blog/posts/DoctorDog";
import TaleOfThreeAgents from "../components/Blog/posts/TailOfThreeAgents";
import AiNativeSemanticsApproach from "../components/Blog/posts/AiNativeSemanticsApproach";
import ThreePillarsTrustworthyAI from "../components/Blog/posts/ThreePillarsTrustworthyAI";
import SemanticGraphsFunctionCalling from "../components/Blog/posts/SemanticGraphsFunctionCalling";
import RiseOfCompositeAI from "../components/Blog/posts/RiseOfCompositeAI";
import BeyondTheSpreadsheet from "../components/Blog/posts/BeyondTheSpreadsheet";
import WhatIfAILearnedYourBusiness from "../components/Blog/posts/WhatIfAILearnedYourBusiness";
import LibrariesToUseCases from "../components/Blog/posts/LibrariesToUseCases";
import AvoidingOntologyLoss from "../components/Blog/posts/AvoidingOntologyLoss";
import TailOfTwoJourneys from "../components/Blog/posts/TailOfTwoJourneys";
import IntentKnowledgeExecutionGap from "../components/Blog/posts/IntentKnowledgeExecutionGap";
import ReasonAcrossSilos from "../components/Blog/posts/ReasonAcrossSilos";
import AiDrivenSemanticsResults from "../components/Blog/posts/AiDrivenSemanticsResults";
import OntologyTax from "../components/Blog/posts/OntologyTax";

export const posts = [
    {
        id: 0,
        t: 'Libraries to Use Cases: Four Stages of Knowledge to Value',
        ex: "The question isn't 'how to curate knowledge'. It's 'what's the path to drive the actual business?'",
        cat: 'Strategy',
        icon: faRoute,
        date: 'Mar 2026',
        c: '#003366',
        rt: '6 min',
        slug: 'libraries-to-use-cases',
        component: LibrariesToUseCases,
    },
    {
        id: 1,
        t: 'AI Native Semantics: Avoiding Ontology Loss',
        ex: "What are you giving up by skipping the formal ontology step? Less than you think.",
        cat: 'Cognition',
        icon: faFileCode,
        date: 'Mar 2026',
        c: '#003366',
        rt: '5 min',
        slug: 'avoiding-ontology-loss',
        component: AvoidingOntologyLoss,
    },
    {
        id: 2,
        t: 'AI Native Semantics: A Tale of Two Journeys',
        ex: "Two paths to semantics. Only one gets you there at the speed your market is about to demand.",
        cat: 'Strategy',
        icon: faCodeCompare,
        date: 'Mar 2026',
        c: '#003366',
        rt: '4 min',
        slug: 'tale-of-two-journeys',
        component: TailOfTwoJourneys,
    },
    {
        id: 3,
        t: 'AI Closes the Intent → Knowledge → Execution Gap',
        ex: "Knowledge as a flywheel, not a foundation. Intent flows forward into execution. Execution feeds back into knowledge.",
        cat: 'Architecture',
        icon: faArrowsRotate,
        date: 'Mar 2026',
        c: '#003366',
        rt: '5 min',
        slug: 'intent-knowledge-execution-gap',
        component: IntentKnowledgeExecutionGap,
    },
    {
        id: 4,
        t: 'Your Business Works in Silos. Your AI Should Reason Across Them.',
        ex: "We're trying to solve a reasoning problem with a modelling exercise. That's why it keeps failing.",
        cat: 'Strategy',
        icon: faLayerGroup,
        date: 'Mar 2026',
        c: '#003366',
        rt: '5 min',
        slug: 'reason-across-silos',
        component: ReasonAcrossSilos,
    },
    {
        id: 5,
        t: 'AI Driven Semantics: Real World Results',
        ex: "Real semantic results from Harrison's Principles of Internal Medicine. All without hallucination and no hand-built ontology.",
        cat: 'Cognition',
        icon: faFlaskVial,
        date: 'Mar 2026',
        c: '#003366',
        rt: '4 min',
        slug: 'ai-driven-semantics-results',
        component: AiDrivenSemanticsResults,
    },
    {
        id: 6,
        t: 'AI Shortcuts the Ontology Tax',
        ex: "Semantic graphs are awesome and needed in an AI world, but we shouldn't have to pay a large tax to adopt them.",
        cat: 'Strategy',
        icon: faReceipt,
        date: 'Mar 2026',
        c: '#003366',
        rt: '5 min',
        slug: 'ontology-tax',
        component: OntologyTax,
    },
    {
        id: 7,
        t: 'What If Your AI Actually Learned Your Business - Not Just Your Data?',
        ex: "The goal was never to sprinkle AI on top of the old operating model. It was an organisation that genuinely teaches itself.",
        cat: 'Strategy',
        icon: faGraduationCap,
        date: 'Mar 2026',
        c: '#003366',
        rt: '5 min',
        slug: 'ai-learned-your-business',
        component: WhatIfAILearnedYourBusiness,
    },
    {
        id: 8,
        t: 'Beyond the Spreadsheet with AI',
        ex: "The spreadsheet isn't the problem. The mindset is.",
        cat: 'Strategy',
        icon: faTableCells,
        date: 'Mar 2026',
        c: '#003366',
        rt: '5 min',
        slug: 'beyond-the-spreadsheet',
        component: BeyondTheSpreadsheet,
    },
    {
        id: 9,
        t: 'The Rise of Composite AI Applications',
        ex: "Layers collapse because they were never natural boundaries. This is AI-native building: conversation to production in days/weeks.",
        cat: 'Architecture',
        icon: faCubes,
        date: 'Mar 2026',
        c: '#003366',
        rt: '5 min',
        slug: 'rise-of-composite-ai',
        component: RiseOfCompositeAI,
    },
    {
        id: 10,
        t: 'Semantic Graphs and AI Function Calling',
        ex: "Function classification and parameter extraction running locally on a laptop. No API calls to external LLMs. Sub-30ms latency.",
        cat: 'Architecture',
        icon: faTerminal,
        date: 'Mar 2026',
        c: '#003366',
        rt: '5 min',
        slug: 'semantic-graphs-function-calling',
        component: SemanticGraphsFunctionCalling,
    },
    {
        id: 11,
        t: 'The Micro-Agent Trap: Why Fewer Deep Process Agents is Smarter',
        ex: "If you need elaborate infrastructure to coordinate your agents, you have too many agents.",
        cat: 'Architecture',
        icon: faRobot,
        date: 'Feb 2026',
        c: '#003366',
        rt: '6 min',
        slug: 'micro-agent-trap',
        component: MicroAgentTrap,
    },
    {
        id: 12,
        t: 'Sunday Reflections: The AI-Native Organisation',
        ex: "What does it actually mean to design for AI-native rather than just bolting AI onto what we already have?",
        cat: 'Strategy',
        icon: faBuilding,
        date: 'Feb 2026',
        c: '#003366',
        rt: '6 min',
        slug: 'ai-native-organisation',
        component: AiNativeOrganisation,
    },
    {
        id: 13,
        t: 'Decision Spaces: Putting Agents on Rails',
        ex: "Most agent architectures aren't built for trust - they're built for impressive demos that make compliance teams nervous.",
        cat: 'Architecture',
        icon: faTrain,
        date: 'Feb 2026',
        c: '#003366',
        rt: '5 min',
        slug: 'decision-spaces',
        component: DecisionSpaces,
    },
    {
        id: 14,
        t: 'Agentic Enterprise: Organisations in Motion',
        ex: "When agents learn through execution, the distinction between process and organisation dissolves.",
        cat: 'Strategy',
        icon: faDiagramProject,
        date: 'Feb 2026',
        c: '#003366',
        rt: '5 min',
        slug: 'agentic-enterprise',
        component: AgenticEnterprise,
    },
    {
        id: 15,
        t: "Agents Don't Need Coordination. Processes Do.",
        ex: "The unit of work isn't the agent - it's actually the process.",
        cat: 'Architecture',
        icon: faSitemap,
        date: 'Feb 2026',
        c: '#003366',
        rt: '5 min',
        slug: 'agents-process-coordination',
        component: AgentsProcessCoordination,
    },
    {
        id: 16,
        t: 'Agents, Handovers, and Shared Systems',
        ex: "The interconnected organisation doesn't need everyone speaking the same language - it needs clear contracts at the boundaries.",
        cat: 'Architecture',
        icon: faArrowRightArrowLeft,
        date: 'Feb 2026',
        c: '#003366',
        rt: '5 min',
        slug: 'agent-handovers',
        component: AgentHandovers,
    },
    {
        id: 17,
        t: 'AI Native Processes: Building Learning Systems',
        ex: "The process is the knowledge in motion. The knowledge is the process made explicit.",
        cat: 'Architecture',
        icon: faGears,
        date: 'Feb 2026',
        c: '#003366',
        rt: '5 min',
        slug: 'ai-native-processes',
        component: AiNativeProcesses,
    },
    {
        id: 18,
        t: 'The Knowledge Revolution Is Happening Now',
        ex: "From design-time to runtime. From define-then-execute to execute-and-learn.",
        cat: 'Cognition',
        icon: faLightbulb,
        date: 'Feb 2026',
        c: '#003366',
        rt: '5 min',
        slug: 'knowledge-revolution',
        component: KnowledgeRevolution,
    },
    {
        id: 19,
        t: 'AI Native Semantics: Move 37 For Encoding Knowledge',
        ex: "The assumption that meaning must flow through human abstraction before machines can use it may no longer hold.",
        cat: 'Cognition',
        icon: faChessKnight,
        date: 'Feb 2026',
        c: '#003366',
        rt: '6 min',
        slug: 'move-37-semantics',
        component: Move37Semantics,
    },
    {
        id: 20,
        t: 'Context Graphs: Agents Making and Learning from THEIR Decisions',
        ex: "Decision traces are captured in the execution path, not defined upfront in workshops.",
        cat: 'Architecture',
        icon: faCircleNodes,
        date: 'Feb 2026',
        c: '#003366',
        rt: '5 min',
        slug: 'context-graphs-clarity',
        component: ContextGraphsClarity,
    },
    {
        id: 21,
        t: 'Dynamic Emergent Systems: The Legacy Thinking Holding Us Back',
        ex: "Everybody has a plan until they get punched in the face.",
        cat: 'Strategy',
        icon: faBolt,
        date: 'Feb 2026',
        c: '#003366',
        rt: '5 min',
        slug: 'dynamic-emergent-systems',
        component: DynamicEmergentSystems,
    },
    {
        id: 22,
        t: 'Context Graphs: A Time Machine for Business Decisions',
        ex: "Not just what happened, but why the Agent made the decision.",
        cat: 'Architecture',
        icon: faClock,
        date: 'Feb 2026',
        c: '#003366',
        rt: '4 min',
        slug: 'context-graphs-time-machine',
        component: ContextGraphsTimeMachine,
    },
    {
        id: 23,
        t: 'Context Graphs: State, Knowledge, Decision - Truth in the Moment',
        ex: "Memory isn't abstract. Memory is point in time.",
        cat: 'Architecture',
        icon: faHistory,
        date: 'Feb 2026',
        c: '#003366',
        rt: '4 min',
        slug: 'context-graphs-point-in-time',
        component: ContextGraphsPointInTime,
    },
    {
        id: 24,
        t: 'AI-Native Semantics: Building the 21st Century Organisation',
        ex: "The 21st Century Organisation is nimble, reactive & adaptive. Not because they planned better - because they stopped trying to plan everything.",
        cat: 'Strategy',
        icon: faRocket,
        date: 'Feb 2026',
        c: '#003366',
        rt: '5 min',
        slug: 'building-21st-century-org',
        component: Building21stCenturyOrg,
    },
    {
        id: 25,
        t: 'Context Graphs and Knowledge Flywheel for Agents',
        ex: "A living blueprint of a business that changes at the speed it does.",
        cat: 'Architecture',
        icon: faRotate,
        date: 'Feb 2026',
        c: '#003366',
        rt: '6 min',
        slug: 'knowledge-flywheel',
        component: KnowledgeFlywheel,
    },
    {
        id: 26,
        t: 'Context Graphs: A Tangled Web Of Confusion',
        ex: "State Machines, Workflows, and Agents - understanding the fundamental problem space.",
        cat: 'Architecture',
        icon: faCodeBranch,
        date: 'Feb 2026',
        c: '#003366',
        rt: '5 min',
        slug: 'context-graphs-confusion',
        component: ContextGraphsConfusion,
    },
    {
        id: 27,
        t: 'Knowledge Graphs vs Context Graphs: Maps vs GPS',
        ex: "A knowledge graph is a map. A context graph is your GPS navigation.",
        cat: 'Architecture',
        icon: faMapLocationDot,
        date: 'Feb 2026',
        c: '#003366',
        rt: '5 min',
        slug: 'knowledge-vs-context-graphs',
        component: KnowledgeVsContextGraphs,
    },
    {
        id: 28,
        t: 'Context Graphs: Where AI, Data, and Software Collide',
        ex: "The graph isn't asked questions - it runs and adapts as it learns.",
        cat: 'Architecture',
        icon: faNetworkWired,
        date: 'Feb 2026',
        c: '#003366',
        rt: '5 min',
        slug: 'context-graphs-collision',
        component: ContextGraphsCollision,
    },
    {
        id: 29,
        t: 'A New Era of Information Representation with AI',
        ex: "We aren't replacing human knowledge and expertise - we're relocating where it matters most.",
        cat: 'Cognition',
        icon: faDatabase,
        date: 'Feb 2026',
        c: '#003366',
        rt: '5 min',
        slug: 'new-era-information-representation',
        component: NewEraInformationRepresentation,
    },
    {
        id: 30,
        t: 'Doctor Dog: Building ConsistentAI Agents',
        ex: "AI agents that 'discover, reason, and act' sound great - until you need to trust them with clinical decisions.",
        cat: 'Architecture',
        icon: faUserDoctor,
        date: 'Feb 2026',
        c: '#003366',
        rt: '6 min',
        slug: 'doctor-dog',
        component: DoctorDog,
    },
    {
        id: 31,
        t: 'A Tale of Three Agents',
        ex: "The real magic happens when you combine them - use the Artist to design the tracks, then let the Conductor run them.",
        cat: 'Architecture',
        icon: faTheaterMasks,
        date: 'Feb 2026',
        c: '#003366',
        rt: '5 min',
        slug: 'tale-of-three-agents',
        component: TaleOfThreeAgents,
    },
    {
        id: 32,
        t: 'AI-Native Semantics: A Different Approach',
        ex: "AI that discovers, reasons, acts - but you can trust.",
        cat: 'Architecture',
        icon: faChartLine,
        date: 'Feb 2026',
        c: '#003366',
        rt: '6 min',
        slug: 'ai-native-semantics-approach',
        component: AiNativeSemanticsApproach,
    },
    {
        id: 33,
        t: 'The Three Pillars of Trustworthy Agentic AI',
        ex: "The gap isn't intelligence - it's architecture. Semantics, Execution, and Context State working together.",
        cat: 'Architecture',
        icon: faBuildingColumns,
        date: 'Feb 2026',
        c: '#003366',
        rt: '5 min',
        slug: 'three-pillars-trustworthy-ai',
        component: ThreePillarsTrustworthyAI,
    },
    {
        id: 34,
        t: 'AI-Native Semantics: Why We Moved Past Ontologies',
        ex: "Traditional ontologies broke the moment we encoded more than one view of a domain. So we flipped it.",
        cat: 'Cognition',
        icon: faBrain,
        date: 'Feb 2026',
        c: '#003366',
        rt: '5 min',
        slug: 'ai-native-semantics',
        component: AiNativeSemantics,
    },
    {
        id: 35,
        t: 'Provenance by Design: Why Not All Language Models Are Created Equal',
        ex: "Standard LLMs strip provenance from knowledge systematically. We built a model that preserves it.",
        cat: 'Cognition',
        icon: faShieldHalved,
        date: 'Feb 2026',
        c: '#003366',
        rt: '4 min',
        slug: 'provenance-by-design',
        component: ProvenanceByDesign,
    },

];
